




















import { computed, defineComponent, onMounted, onUnmounted, ref } from "@vue/composition-api";
import { debounce } from "lodash-es";
import useAuthUser from "@/hooks/useAuthUser";
import type { TabField } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import CustomScroll from "@/components/CustomScroll";
import SiteLogo from "@/components/SiteLogo";

export default defineComponent({
  name: "TabsHeader",
  components: { BaseIconButton, CustomScroll, SiteLogo },
  props: {
    tabs: { type: Array as () => TabField[], required: true },
    active: { type: String },
  },
  setup() {
    const { authUser } = useAuthUser();
    const scrolled = ref(false);
    const wrapper = ref<HTMLElement>();

    const attrName = computed(() => (authUser.value ? "" : "href"));

    const calculateVisibleTags = async () => {
      if (!wrapper.value) return;
      scrolled.value = wrapper.value.offsetWidth < wrapper.value.scrollWidth;
    };

    const onResize = debounce(calculateVisibleTags, 10, { leading: true, trailing: true });

    onMounted(() => {
      calculateVisibleTags();
      window.addEventListener("resize", onResize, { passive: true });
    });

    onUnmounted(() => {
      window.removeEventListener("resize", onResize);
    });

    return { scrolled, attrName, wrapper, calculateVisibleTags };
  },
});
